import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    HostBinding,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from "@angular/core";
import {Subscription} from "rxjs";
import {SessionModel} from "../../../orchestration/session.model";
import {ResponsiveService} from "../../../orchestration/responsive.service";
import {SessionEvents} from "../../../orchestration/session-events";
import {OrderModel} from "../../../order/order.model";
import {MessageLevel} from "../../../notification/message/message";
import {PaymentModel} from "../../payment.model";
import {PaymentEvents} from "../../payment-events";
import {CardPaymentSubmissionResult, PaymentAuthorisationType, PaymentCard} from "../../payment";

@Component({
    selector: "woa-adyen-manual-payment-card-panel",
    templateUrl: "./adyen-manual-payment-card-panel.component.html",
    providers: [{provide: PaymentCard, useExisting: AdyenManualPaymentCardPanelComponent}]
})
export class AdyenManualPaymentCardPanelComponent extends PaymentCard implements OnInit, AfterViewInit, OnChanges, OnDestroy {
    @Input() @HostBinding("class.disabled") disabled: boolean = false;

    @Output() onPayFormReady: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild("cardHolder") cardHolder: ElementRef;

    MessageLevel = MessageLevel;

    savePaymentDetails: boolean = false;
    payFormError: string;

    private _hidden: boolean = false;
    private hasBeenUnhidden: boolean = false;
    private setupStarted: boolean = false;
    private payFormReady: boolean = false;
    private adyenCheckout: any;
    private adyenCard: any;
    private submitted: boolean = false;
    private submissionResult: CardPaymentSubmissionResult = new CardPaymentSubmissionResult(PaymentAuthorisationType.ADYEN_PAYMENT_METHOD);
    private subscriptions: Subscription = new Subscription();
    private destroyed: boolean = false;

    constructor(private sessionModel: SessionModel,
                private changeDetectorRef: ChangeDetectorRef,
                private responsiveService: ResponsiveService,
                private orderModel: OrderModel,
                private paymentModel: PaymentModel) {
        super();
        this.savePaymentDetails = this.responsiveService.isMobile || this.sessionModel.devOrDemoMode;
    }

    @Input()
    set hidden(hidden: boolean) {
        this._hidden = hidden;
        if (!hidden) {
            if (!this.hasBeenUnhidden) {
                setTimeout(() => this.setup());
            }
            this.hasBeenUnhidden = true;
        }
    }

    get hidden(): boolean {
        return this._hidden;
    }

    get showSpinner(): boolean {
        return !this.hidden && (!this.paymentModel.paymentPlatformPublicKey || (!this.payFormReady && !this.payFormError));
    }

    get showSavePaymentDetailsOption(): boolean {
        return !this.sessionModel.waiterMode;
    }

    ngOnInit(): void {
        PaymentEvents.paymentDetailsApplied$.subscribe(() => this.setup());
        this.subscriptions.add(SessionEvents.currentApp$.subscribe(() => {
            this.changeDetectorRef.detectChanges();
        }));
    }

    async ngAfterViewInit(): Promise<void> {
        return this.setup();
    }

    async ngOnChanges(): Promise<void> {
        return this.setup();
    }

    ngOnDestroy(): void {
        this.destroyed = true;
        this.subscriptions.unsubscribe();
        if (this.adyenCard) {
            this.adyenCard.unmount();
        }
    }

    canSavePaymentDetails(): boolean {
        return this.showSavePaymentDetailsOption && this.savePaymentDetails;
    }

    isValid(): boolean {
        this.submitted = true;
        if (!this.adyenCard) {
            return false;
        }
        if (!this.adyenCard.isValid) {
            this.adyenCard.showValidation();
            return false;
        }
        return true;
    }

    markAsUnsubmitted(): void {
        this.submitted = false;
    }

    async submit(): Promise<CardPaymentSubmissionResult> {
        this.submissionResult.token = btoa(JSON.stringify(this.adyenCard.data));
        return this.submissionResult;
    }

    async setup(): Promise<void> {
        if (this.destroyed || !this.hasBeenUnhidden || this.setupStarted || !this.paymentModel.paymentPlatformPublicKey || !this.cardHolder) {
            return;
        }

        this.setupStarted = true;
        this.adyenCheckout = await (<any>window).AdyenWeb.AdyenCheckout({
            clientKey: this.paymentModel.paymentPlatformPublicKey,
            environment: this.paymentModel.paymentPlatformLiveMode ? "live-au" : "test",
            locale: "en_US",
            countryCode: "AU",
            paymentMethodsResponse: JSON.parse(this.paymentModel.paymentMethods),
            amount: {
                value: Math.floor(this.orderModel.initiatedOrder.orderTotal * 100),
                currency: "AUD"
            },
            showPayButton: false
        });
        // noinspection JSUnusedGlobalSymbols
        this.adyenCard = new (<any>window).AdyenWeb.Card(this.adyenCheckout, {
            onConfigSuccess: () => {
                this.payFormReady = true;
                setTimeout(() => this.onPayFormReady.emit(true), 250);
            },
            onBrand: (result: {
                brand: string
            }) => this.submissionResult.brand = result.brand,
            onFieldValid: (result: {
                fieldType: string,
                endDigits: string
            }) => {
                if (result.fieldType === "encryptedCardNumber") {
                    this.submissionResult.last4 = result.endDigits;
                }
            },
            onBinLookup: (result: {
                issuingCountryCode: string
            }) => this.submissionResult.country = result.issuingCountryCode,
            onError: (error: string) => {
                console.error("Adyen card error", error);
                this.payFormError = error;
                setTimeout(() => this.onPayFormReady.emit(false), 300);
                this.changeDetectorRef.detectChanges();
            }
        }).mount(this.cardHolder.nativeElement);
    }
}



// WEBPACK FOOTER //
// ./src/app/payment/card-payment/adyen-manual-payment-card-panel/adyen-manual-payment-card-panel.component.ts